import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigSharedService} from '../../services/get-config-shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ActionsSubject, select, Store} from '@ngrx/store';
import * as fromShared from '../../reducers';
import { DuplicateContract} from '../../models/contract-link';
import {Contract} from '../../../contract/models/contract';
import {DuplicationContractAction, DuplicationContractSuccessAction} from '../../actions/contract-duplication';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import {LoadContractAction} from '../../../contract/actions/contract-load';
import { LoadRulesContractIDAction, RulesClearAction} from '../../../contract/actions/contract-rules-load';
import {Rules, RulesForm} from '../../../contract/models/rules';
import {DuplicationRuleAction} from '../../actions/rule-duplication';
import * as fromContracts from '../../../contract/reducers';
import {LoadMyCompaniesLinkContractAction} from '../../actions/companies-link-contract';
import {CompanyService} from '../../../company/services/company.service';
import {RulesMapperService} from '../../../contract/services/rules-mapper.service';
import {ContractMapperService} from '../../../contract/services/contract-mapper.service';
import {BsModalRef, ModalDirective} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import {UpdateDynamicFormService} from '../../services/update-dynamic-form.service';
import {DuplicateService} from '../../services/duplicate.service';
import * as moment from 'moment';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {LoadContractsAction} from '../../../contract/actions/contracts-list';

@Component({
  selector: 'storever-duplicate-contract-modal',
  templateUrl: './duplicate-contract-modal.component.html',
  styleUrls: ['./duplicate-contract-modal.component.scss']
})
export class DuplicateContractModalComponent implements OnInit, OnDestroy {
  @ViewChild('staticModal' , {static: false}) public staticModal: ModalDirective;
  private sub$: Subscription;
  private subscriptions = [];
  // tslint:disable-next-line:no-any
  @Input() contractForm: any;
  @Input() ruleForm: RulesForm;
  @Input() companyName: string = null;
  @Input() companyUuid: string = null;
  rules$: Observable<Rules[]>;
  contract$: Observable<Contract>;
  myForm: FormGroup;
  formConfig: GroupConfig;
  contractUuId: string;
  error = 'false';
  errorName = 'false';
  contractNamePrefix: string;

  constructor(private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private activatedRoute: ActivatedRoute,
              private storeContract: Store<fromContracts.AppState>,
              private dispatcher: ActionsSubject,
              private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private bsModalRef: BsModalRef,
              private companyService: CompanyService,
              private rulesMapperService: RulesMapperService,
              private contractMapperService: ContractMapperService,
              private duplicate: DuplicateService,
              private updateDynamicFormService: UpdateDynamicFormService,
              private store: Store<fromShared.AppState>) {

  }

  ngOnInit(): void {
    this.myForm = this.getFormsService.getDuplicationContract();
    this.formConfig = this.getConfigSharedService.getDuplicationContract();
    this.store.dispatch(new LoadMyCompaniesLinkContractAction());
    this.patchForm();
    this.watchName();
    this.duplicationNameValidator();
    this.checkValidityDate();


  }

  duplicationNameValidator(): void {
    this.sub$ = this.myForm.get(['name']).valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(name => {
      this.nameExist(name);
    })
    this.subscriptions.push(this.sub$);
  }

  nameExist(name: string): void {
    const nameDup = (this.contractNamePrefix ? this.contractNamePrefix : this.myForm.get(['name']).value) + name
    this.sub$ =  this.duplicate.duplicate(['contractName'] ,  nameDup , 'duplication').pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y)  ),
    ).subscribe((res: boolean) => {
      if (res === true) {
        this.myForm.get(['name']).setErrors({  });
        this.updateDynamicFormService.updateElement('name', true, 'duplicate');
        this.errorName = 'true';
      } else {
        this.myForm.get(['name']).setErrors(null);
        this.updateDynamicFormService.updateElement('name', false, 'duplicate');
        this.errorName = 'false';
      }
    })
    this.subscriptions.push(this.sub$);
  }
  watchName(): void {
    // this.sub$ = this.myForm.get('name').valueChanges.subscribe(name => {
    //   if (this.contractForm.displayName.displayName.trim() === name.trim()) {
    //    this.errorName = 'Duplicate name'
    //   } else {
    //     this.errorName = 'false';
    //   }
    // })
    // this.subscriptions.push(this.sub$);
  }
  get isEdit(): boolean {
    if (this.activatedRoute.snapshot.routeConfig) {
      return this.activatedRoute.snapshot.routeConfig.path === 'detail/:contractId'
    } else {
      return false
    }
  }

  send(value: DuplicateContract): void {
      this.storeContract.dispatch(new RulesClearAction());
      if (!value.end || value.end === 'Invalid date') {
        this.contractForm.invoicing.end = '2099-12-31'
      } else {
        this.contractForm.invoicing.end = value.end;
      }
      this.contractForm.invoicing.start = value.start;
      this.contractForm.name = value.name;
      this.contractForm.displayName.displayName = value.name;
      this.contractForm.uuid = null;
      this.store.dispatch(new DuplicationContractAction({ contractForm: this.contractForm, companyUuid: value.companyUuid }));

      this.sub$ = this.dispatcher.pipe(
        filter(action => action.type === '[contract] Duplicate Success'),
      ).subscribe((data: DuplicationContractSuccessAction) => {
        this.contractUuId = data.payload.uuid;
        if (value.isRuleDuplicate) {
          this.storeContract.dispatch(new LoadRulesContractIDAction(this.contractUuId));
          this.rules$ = this.storeContract.pipe(select(fromContracts.selectors.getRules));
          this.sub$ = this.rules$.subscribe((rules: Rules[]) => {
            if (rules) {
              // console.log('LoadContractsAction')
              this.ruleForm.id = rules[rules.length - 1].id;
              this.ruleForm.contractID = rules[rules.length - 1].contractID;
              this.ruleForm.contractUuId = this.contractUuId;
              this.ruleForm.start = rules[rules.length - 1].start;
              this.ruleForm.end = rules[rules.length - 1].end;
              this.store.dispatch(new DuplicationRuleAction({ ruleForm: this.ruleForm, contractUuid: this.contractUuId }));
              if (this.isEdit) {
                this.router.navigate(  ['/', this.companyUuid, 'contracts', 'detail', this.contractUuId], {fragment: 'Contract' });
              }
              this.router.navigate(['/', 'companies', 'detail', value.companyUuid], { fragment: 'Contracts' });
            }
          });
          this.subscriptions.push(this.sub$);
        } else {
          if (this.isEdit) {
            this.router.navigate(  ['/', this.companyUuid, 'contracts', 'detail', this.contractUuId], {fragment: 'Contract' });
          //  console.log('LoadContractsAction')
          }
          this.router.navigate(['/', 'companies', 'detail', value.companyUuid], { fragment: 'Contracts' });
          // console.log('LoadContractsAction')
          this.storeContract.dispatch(new LoadContractsAction());

        }
      });
      this.subscriptions.push(this.sub$);
      this.close();
  }

  open(): void {
    this.formConfig = this.getConfigSharedService.getDuplicationContract();
    if (this.contractForm) {
      this.patchForm();
    }
    this.staticModal.show();
  }

  close(): void {
    this.formConfig.config[0].options.inputExtraLabels = null;
    if (this.staticModal) {
      this.staticModal.hide();
    } else {
      this.bsModalRef.hide();
    }
  }

  patchForm(): void {
    if (!this.companyName && this.companyUuid) {
      this.getCompanyName();
    } else {
      this.contractNamePrefix = this.contractForm.prefix;
      this.formConfig.config[0].options.inputExtraLabels = this.contractNamePrefix;
      this.myForm.patchValue({
        companyName: this.companyName,
        companyUuid: this.companyUuid,
        prefix: this.contractNamePrefix,
      });
      this.nameExist('');
    }

  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  //  this.storeContract.dispatch(new RulesClearAction());
  //  this.storeContract.dispatch(new ClearContractsAction());
  }

  // this fonction is used when we call this modal via data table
  closeBSF(): void {
    this.bsModalRef.hide();
  }

  getCompanyName(): void {
    this.sub$ = this.companyService.load(this.companyUuid).subscribe(c => {
      if (c && c.data) {
        this.companyName = c.data.name;
        this.companyUuid = c.data.uuid;
        this.contractNamePrefix = this.contractForm.prefix;
        this.formConfig.config[0].options.inputExtraLabels = this.contractNamePrefix;
        this.myForm.patchValue({
          companyName: this.companyName,
          companyUuid: this.companyUuid,
          prefix: this.contractNamePrefix,
        });
        this.nameExist('');
      }
    });
    this.subscriptions.push(this.sub$);
    if (this.contractForm.uuid) {
       this.getContractAndRule();
    }
  }

  getContractAndRule(): void {
    this.storeContract.dispatch(new LoadRulesContractIDAction(this.contractForm.uuid));
    this.rules$ = this.storeContract.pipe(select(fromContracts.selectors.getRules));
    this.sub$ = this.rules$.subscribe((rules: Rules[]) => {
      if (rules && !this.ruleForm.id) {
        this.ruleForm = this.rulesMapperService.dbToForm(rules[rules.length - 1]);
      }
    });
    this.subscriptions.push(this.sub$);


    this.storeContract.dispatch(new LoadContractAction(this.contractForm.uuid));
    this.contract$ = this.storeContract.pipe(select(fromContracts.selectors.getCurrentContract));
    this.sub$ = this.contract$.subscribe((contract: Contract) => {
      if (contract) {
        this.contractForm = this.contractMapperService.contractDbToForm(contract);
      }
    });
    this.subscriptions.push(this.sub$);
  }
  checkValidityDate(): void {
    this.sub$ = this.myForm.valueChanges.subscribe((data) => {
      if (data.start !== 'Invalid date' && data.end !== 'Invalid date') {
        this.error = 'false';
        this.updateErrorDate(data.start , data.end)
      }
    })
    this.subscriptions.push(this.sub$);
  }

  updateErrorDate(start: string , end: string): void {
    if (start && end && !moment(start).isBefore(end)) {
      this.error =  'End date must be bigger than the start date';

    }
  }
}


